import { TypedUseSelectorHook, useSelector } from 'react-redux';
import type { RootState } from '../store';

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const useproductsdataSelectors = () => {
  const appSelector = useAppSelector;
  return {
    Products: appSelector((state: RootState) => state.productsdata.Products),
    Upsells: appSelector((state: RootState) => state.productsdata.Upsells),
    Warranty: appSelector((state: RootState) => state.productsdata.Warranty),
    CampaignData: appSelector((state: RootState) => state.productsdata.campaignData),
    Shipping: appSelector((state: RootState) => state.productsdata.Shipping),
  };
};
